import { render } from "../../templates/partner-cart-classifier.html?vue&type=template&id=37dc99a6"
import script from "./classifier.vue?vue&type=script&lang=js"
export * from "./classifier.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__